const englishUrl = new URL(process.env.NEXT_PUBLIC_WEBSITE_PUBLIC_URL_ENGLISH)

export const getLocaleFromHostname = (hostname: string) => {
  if (hostname === englishUrl.hostname) {
    return 'en'
  }
  return 'de'
}
